export default __webpack_public_path__ + "static/media/nextJS.fc272ac2.svg";